import { stringLiteralArray } from "../utils"

export type Breakpoint = typeof breakpoints[number]
export type Breakpoints = { readonly [key in Breakpoint]: number }

const breakpoints = stringLiteralArray(["xs", "sm", "md", "lg", "xl"])

export { breakpoints }
